import { useTranslate } from "@refinedev/core";

export const useDateOptions = () => {
  const translate = useTranslate();

  const getMonthOptions = () => [
    { value: "", label: translate("options.none") },
    { value: 0, label: translate("options.months.0") },
    { value: 1, label: translate("options.months.1") },
    { value: 2, label: translate("options.months.2") },
    { value: 3, label: translate("options.months.3") },
    { value: 4, label: translate("options.months.4") },
    { value: 5, label: translate("options.months.5") },
    { value: 6, label: translate("options.months.6") },
    { value: 7, label: translate("options.months.7") },
    { value: 8, label: translate("options.months.8") },
    { value: 9, label: translate("options.months.9") },
    { value: 10, label: translate("options.months.10") },
    { value: 11, label: translate("options.months.11") }
  ];

  const getYearOptions = (startYear = 2023) => {
    const currentYear = new Date().getFullYear() + 1;

    const years = Array.from({ length: currentYear - startYear + 1 }, (_, i) => ({
      value: (currentYear - i),
      label: (currentYear - i)
    }));

    return [
      { value: "", label: translate("options.none") },
      ...years
    ];
  };

  return { getMonthOptions, getYearOptions };
};
